import { colors } from "@/styles/colors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
	listItemTitle: {
		textTransform: "capitalize",
		lineHeight: "19px",
		wordWrap: "break-word",
		display: "-webkit-box",
		WebkitLineClamp: 2,
		WebkitBoxOrient: "vertical",
		overflow: "hidden",
		textOverflow: "ellipsis"
	},
	tagAssociatedTriggerTitle: {
		fontSize: "12px",
		fontStyle: "normal",
		fontWeight: 500,
		lineHeight: "24px",
		color: colors.gray[300]
	},
	textOverflow: {
		overflow: "hidden",
		textOverflow: "ellipsis",
		maxWidth: "100%",
		borderRadius: "4px"
	},
	triggerInfo: {
		width: "80%",
		flexWrap: "inherit"
	}
}))

export default useStyles
